import { Directive, ElementRef, HostListener } from '@angular/core'

@Directive({
  selector: '[mbOneClickAllowed]',
})
export class MbOneClickAllowedDirective {

  constructor (protected el: ElementRef) { }

  @HostListener('click')
  private onClick () {
    this.el.nativeElement.disabled = true
    setTimeout(() => this.el.nativeElement.disabled = false, 3000)
  }
}
